import type { InventoryListFilterValue, InventoryListSettings } from "@slfinrtl/ui-bff-routes"

export const getDefaultSettings = (defaultDealership?: string): InventoryListSettings => ({
	...getDefaultFilterValue(defaultDealership),
	sortBy: "salesStatus",
	sortDir: "ASC",
})

const getDefaultFilterValue = (defaultDealership?: string): InventoryListFilterValue => ({
	accidentFree: false,
	bodyTypes: [],
	dealershipIds: defaultDealership ? [defaultDealership] : [],
	derivatives: [],
	driveTrains: [],
	enginePowerUnit: "kW",
	engineTypes: [],
	equipmentTags: [],
	exteriorColors: [],
	interiorColors: [],
	listingQuality: [],
	listingVisibility: [],
	maxFirstRegistrationDate: "",
	maxMileage: "",
	maxModelYear: "",
	maxPrice: "",
	minEnginePower: "",
	minFirstRegistrationDate: "",
	minModelYear: "",
	modelGenerations: [],
	modelSeries: "",
	onlineOrderableStatus: [],
	previousOwners: "",
	salesStatus: [],
	search: "",
	stockStatus: [],
	transmissions: [],
	vatDeductible: false,
	vehicleTypes: [],
})
